var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17V6H2V4C2 2.89333 2.39049 1.95 3.17146 1.17C3.95229 0.389999 4.89674 0 6.00479 0C7.11271 0 8.05556 0.389999 8.83333 1.17C9.61111 1.95 10 2.89333 10 4V6H12V17H0ZM1.5 15.5H10.5V7.5H1.5V15.5ZM6.00437 13C6.41813 13 6.77083 12.8527 7.0625 12.5581C7.35417 12.2635 7.5 11.9094 7.5 11.4956C7.5 11.0819 7.35271 10.7292 7.05812 10.4375C6.76354 10.1458 6.40938 10 5.99563 10C5.58188 10 5.22917 10.1473 4.9375 10.4419C4.64583 10.7365 4.5 11.0906 4.5 11.5044C4.5 11.9181 4.64729 12.2708 4.94187 12.5625C5.23646 12.8542 5.59062 13 6.00437 13ZM3.5 6H8.5V4C8.5 3.30556 8.25694 2.71528 7.77083 2.22917C7.28472 1.74306 6.69444 1.5 6 1.5C5.30556 1.5 4.71528 1.74306 4.22917 2.22917C3.74306 2.71528 3.5 3.30556 3.5 4V6Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.320f5bbc0f515cb5f9de179edd3d37c5.svg";
export { ForwardRef as ReactComponent };